export const groupInvitePath = '/g/';
export const indivInvitePath = '/l/';
export const days = ['sunday', 'monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday'];
export const primaryHex = '#1e62b4';
export const PORTAL_ID = 'portalId';
